import { Flex, Box } from '../../../../shared/layouts';
import FileItem, { FileItemVariant } from './FileItem';
import {useTranslation} from "react-i18next";
import {FC, ReactChild} from "react";

export interface FileProps {
  fileId: number;
  fileName: string;
  downloadUrl?: string;
  message?: {
    message: string;
    severity: 'error' | 'warning';
  };
}

interface FileListProps {
  data: FileProps[];
  header?: ReactChild;
  variant?: FileItemVariant;
  fileAction?: (File) => void;
  allowEmpty?: boolean;
  isLoadingWhileEmpty?: boolean;
}

const FileList: FC<FileListProps> = ({
  data,
  header,
  variant = 'default',
  fileAction,
  allowEmpty,
  isLoadingWhileEmpty,
}) => {
  const { t } = useTranslation();
  const hasData = data.length > 0;

  return hasData || allowEmpty ? (
    <Box>
      {header && (
        <Flex
          height="32px"
          fontScale="m"
          fontWeight="bold"
          justifyContent="space-between"
          alignItems="center"
          mb="s"
          p={{ mobile: '0 16px', desktop: 0 }}
        >
          {header}
        </Flex>
      )}
      <div>
        {hasData ? (
          data.map((file) => (
            <FileItem
              key={file.fileId}
              name={file.fileName}
              variant={variant}
              onClick={fileAction ? () => fileAction(file) : null}
              downloadUrl={file.downloadUrl ?? null}
              message={file.message?.message}
              severity={file.message?.severity}
            />
          ))
        ) : (
          <Box textAlign="center" p="l">
            {isLoadingWhileEmpty ? t('Bezig met laden') : t('Geen bestanden gevonden')}
          </Box>
        )}
      </div>
    </Box>
  ) : null;
};

export default FileList;
